import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import { configure } from 'vue-gtag'
import './styles/globals.css'
import './index.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
import i18n from './i18n'
import './config/firebase' // Inicializar Firebase

const app = createApp(App)
const head = createHead()

app.use(router)
app.use(i18n)
app.use(head)

// Configurar Google Analytics
configure({
  tagId: 'G-LRQK1N61H5'
})

app.mount('#app')
